export default __webpack_public_path__ + "static/media/OnboardingGraph.50772749.svg";